module.exports = __webpack_public_path__ + "static/media/sneak_peek_onboarding@3x.17f58b89.png";